import { render, staticRenderFns } from "./VipBottom.vue?vue&type=template&id=b3249902&scoped=true&"
import script from "./VipBottom.vue?vue&type=script&lang=js&"
export * from "./VipBottom.vue?vue&type=script&lang=js&"
import style0 from "./VipBottom.vue?vue&type=style&index=0&id=b3249902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3249902",
  null
  
)

export default component.exports